module.exports = __webpack_public_path__ + "static/media/account-active.31165f91.svg";